module.exports = __webpack_public_path__ + "static/media/flight-banner.dd0eea3d.png";